import baseTheme from "style/baseTheme";

export * from "style/types/ThemeInterface";

export default baseTheme;
